module.exports = __webpack_public_path__ + "img/facebook-gray.004da1b.png";